import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, OnInit } from '@angular/core';
import { FacetValue, ProductSearchService, RoutingService, WindowRef } from '@spartacus/core';
import { FacetComponent, FacetService } from '@spartacus/storefront';
import { FacetComponentService } from '../../../../features/services/facet-component.service';
import { HisenseFacetService } from '../../../../features/services/facet.service';

@Component({
  selector: 'cx-facet',
  templateUrl: 'facet.component.html',
  styleUrls: ['facet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HisenseFacetComponent extends FacetComponent implements OnInit {
  protected semanticRoute!: string | undefined;
  protected productSearchService = inject(ProductSearchService);
  protected facetComponentService = inject(FacetComponentService);
  protected routing = inject(RoutingService);
  protected override facetService = inject(HisenseFacetService);

  constructor(
    facetService: FacetService,
    elementRef: ElementRef<HTMLElement>,
    cd: ChangeDetectorRef,
    private winRef: WindowRef
  ) {
    super(facetService, elementRef, cd);
  }

  ngOnInit(): void {
    this.routing.getRouterState().subscribe((routerState) => {
      this.semanticRoute = routerState.state.semanticRoute;
    });
  }

  facetClick(facetValue: FacetValue) {
    if (this.winRef.isBrowser()) {
      if (!facetValue.selected && this.semanticRoute === 'category') {
        this.productSearchService
          .getResults()
          .subscribe((productSearch) => {
            if (productSearch.breadcrumbs !== undefined) {
              this.facetComponentService.dispatchGa4GgCategoryListingFacetSelectEvent(
                facetValue.name ? facetValue.name : '',
                productSearch.breadcrumbs[0].facetValueName ? productSearch.breadcrumbs[0].facetValueName : ''
              );
            }
          })
          .unsubscribe();
      }

      if (!this.winRef.document.body.classList.contains('modal-open')) {
        const element = this.winRef.document.getElementsByTagName('cx-product-list')[0];
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }

  override getLinkParams(value: FacetValue): { [key: string]: string } {
    const query = value.query?.query?.value;
    if (query) {
      return this.facetService.getLinkParams(query);
    }
    return {};
  }
}
